import { render, staticRenderFns } from "./Dashboard-Navbar.vue?vue&type=template&id=4a7e17fc&scoped=true&"
import script from "./Dashboard-Navbar.vue?vue&type=script&lang=js&"
export * from "./Dashboard-Navbar.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-Navbar.vue?vue&type=style&index=0&id=4a7e17fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7e17fc",
  null
  
)

export default component.exports